/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetProducts200ResponseAllOfData } from './GetProducts200ResponseAllOfData';
import {
    GetProducts200ResponseAllOfDataFromJSON,
    GetProducts200ResponseAllOfDataFromJSONTyped,
    GetProducts200ResponseAllOfDataToJSON,
} from './GetProducts200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetProducts200ResponseAllOf
 */
export interface GetProducts200ResponseAllOf {
    /**
     * 
     * @type {GetProducts200ResponseAllOfData}
     * @memberof GetProducts200ResponseAllOf
     */
    data: GetProducts200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetProducts200ResponseAllOf interface.
 */
export function instanceOfGetProducts200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetProducts200ResponseAllOfFromJSON(json: any): GetProducts200ResponseAllOf {
    return GetProducts200ResponseAllOfFromJSONTyped(json, false);
}

export function GetProducts200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProducts200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetProducts200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetProducts200ResponseAllOfToJSON(value?: GetProducts200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetProducts200ResponseAllOfDataToJSON(value.data),
    };
}

